<div style="background-color: #f9fbfc; height: 110vh">
  <router-outlet> </router-outlet>
</div>

